<script lang="ts">
  import { stores } from "module/store/SettingsStore";
  import type { ModuleSetting } from "module/store/ModuleSettings";
  import FormGroup from "./FormGroup.svelte";

  let {
    label,
    setting,
    notes,
    sub = false,
  }: {
    label: string;
    setting: string;
    notes?: string;
    sub?: boolean;
  } = $props();

  const checked = stores[setting as ModuleSetting] as SvelteStore<boolean>;
</script>

<FormGroup {sub}>
  <label for={setting}>{label}</label>
  <div class="form-fields">
    <input
      type="checkbox"
      name={setting}
      id={setting}
      data-dtype="Boolean"
      bind:checked={$checked}
    />
  </div>

  {#if notes}
    <p class="hint">
      {notes}
    </p>
  {/if}
</FormGroup>

<style>
  label {
    white-space: nowrap;
  }
</style>
